export default __webpack_public_path__ + "static/media/lux-register.1f19305d.png";